/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="63.15"
        height="83"
        viewBox="0 0 63.15 83"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M61.9 0H22.46a1.23 1.23 0 0 0-.87.36L.38 21.21a1.27 1.27 0 0 0-.38.89v59.61a1.25 1.25 0 0 0 1.25 1.25H61.9a1.25 1.25 0 0 0 1.25-1.25V1.21A1.25 1.25 0 0 0 61.9 0Zm-1.25 2.5v78H2.5V22.66L22.97 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M22.28.01h.63l.14.06.09.06.11.08.1.09.09.11v.06l.07.1v.64l.24 20.7a1.26 1.26 0 0 1-.92 1.3h-.12l-21.45.19a1.25 1.25 0 0 1-1-2l.09-.09L21.57.41l.09-.08.11-.08.11-.06h.19Zm-1.04 4.2L4.33 20.86l17.1-.15Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M14.44 29.58a1.23 1.23 0 0 1 1.66-.05l.1.09 10.52 11a1.25 1.25 0 0 1-1.68 1.84l-.1-.1-10.51-11a1.25 1.25 0 0 1 .01-1.78Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M25.26 29.88a1.25 1.25 0 0 1 1.78 1.72l-.09.1-11.1 10.41a1.24 1.24 0 0 1-1.76-.06 1.25 1.25 0 0 1 0-1.67l.09-.09ZM36.98 29.58a1.24 1.24 0 0 1 1.67-.05l.1.09 10.51 11a1.25 1.25 0 0 1 0 1.77 1.27 1.27 0 0 1-1.67 0l-.1-.1-10.51-11a1.25 1.25 0 0 1 0-1.71Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M47.8 29.88a1.25 1.25 0 0 1 1.81 1.72l-.1.1L38.4 42.11a1.252 1.252 0 0 1-1.81-1.73l.1-.09ZM21.18 58.81a24.84 24.84 0 0 1 25.25 2.34 1.25 1.25 0 0 1-1.39 2.06 22.4 22.4 0 0 0-22.84-2.12 22.68 22.68 0 0 0-2.8 1.46l-.33.2-.27.18-.29.2h-.06a1.253 1.253 0 0 1-1.51-2l.2-.14.25-.18.33-.21.38-.24a26 26 0 0 1 3.08-1.55Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'PaperWithDeadFaceIcon';

export default Icon;
